import { Outlet, useLocation } from 'react-router-dom'
import { Header } from './Header'
import { BottomNav } from './BottomNav'

export const AppShell = () => {
  const { pathname } = useLocation()
  return (
    <div className="flex flex-col h-full bg-background">
      <Header />
      {/* pt-14 clears fixed Header; pb-16 clears fixed BottomNav */}
      <main key={pathname} className="flex-1 overflow-y-auto pt-14 pb-16 page-enter">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  )
}
